import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import { useContext } from 'react';

import { ApplicationContext } from '../../../../shared/source/context/context';

import type { FunctionComponent } from 'react';

export const CustomizationInfo: FunctionComponent = () => {
    const { actions, applicationState, translate } = useContext(ApplicationContext);

    const handleReset = (): void => {
        actions.resetCustomization();
        globalThis.location.href = globalThis.location.origin;
    };

    if (applicationState.isDefaultCustomization) {
        return null;
    }

    return (
        <Paper
            elevation={2}
            sx={{
                alignItems: 'center',
                display: 'flex',
                gap: 2,
                justifyContent: 'flex-end',
                paddingRight: '10px',
            }}
        >
            {translate('customization.alert', {
                id: applicationState.customization.map(({ id }) => id).unwrapOr(null),
            })}
            <Divider flexItem={true} orientation="vertical" />
            <Button onClick={handleReset}>{translate('customization.reset')}</Button>
        </Paper>
    );
};
